import { render } from "./CoberturaView.vue?vue&type=template&id=0d907264"
import script from "./CoberturaView.vue?vue&type=script&lang=js"
export * from "./CoberturaView.vue?vue&type=script&lang=js"

import "./CoberturaView.vue?vue&type=style&index=0&id=0d907264&lang=scss"

import exportComponent from "/home/runner/work/topnetms/topnetms/apps/topnetms_site_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__